import { useAppSelector } from '@verantos-dev/core-annotation-tool';
import { useGetAssigmentCount } from '@verantos-dev/feature-annotation-dashboard';

import { selectBatchId, selectProjectId } from '../state/selector';

export interface UseAnnotatorQueueHeaderResult {
  totalTasksCount: number | null;
  pendingTasksCount: number | null;
  finalizedTasksCount: number | null;
  draftTasksCount: number | null;
  completedTasksCount: number | null;
  isAssignmentCountLoading: boolean;
}

export const useAnnotatorQueueHeader = (): UseAnnotatorQueueHeaderResult => {
  const projectId = useAppSelector(selectProjectId);
  const batchId = useAppSelector(selectBatchId);

  const {
    pendingTasksCount: pendingTasksCountData,
    finalizedTasksCount: finalizedTasksCountData,
    totalTasksCount: totalTasksCountData,
    draftTasksCount: draftTasksCountData,
    completedTasksCount,
    isLoading: isAssignmentCountLoading,
  } = useGetAssigmentCount(projectId as string, batchId as string, !projectId || !batchId);

  return {
    totalTasksCount: totalTasksCountData ?? null,
    pendingTasksCount: pendingTasksCountData ?? null,
    finalizedTasksCount: finalizedTasksCountData ?? null,
    draftTasksCount: draftTasksCountData ?? null,
    completedTasksCount: completedTasksCount ?? null,
    isAssignmentCountLoading: isAssignmentCountLoading,
  };
};
